import React, { useId } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useDisclosure } from "../../../hooks/useDisclosure";
import SoftButton from "../../../components/SoftButton";
import SoftTypography from "../../../components/SoftTypography";
import { useEditApiKey } from "../hooks";

/** Changes the selected key status only after the user confirms. */
const ToggleApiKeyStatus = ({ apiKeyId, brandId, active, prefix }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { mutate, isLoading } = useEditApiKey();
  const titleId = useId();
  const descriptionId = useId();

  const action = active ? "Deactivate" : "Activate";

  const handleToggle = () => {
    mutate({ brandId, apiKeyId, active: !active }, { onSuccess: onClose });
  };

  return (
    <>
      <SoftButton
        variant="outlined"
        color="secondary"
        size="small"
        onClick={onOpen}
        disabled={isLoading}
      >
        {action}
      </SoftButton>
      <Dialog
        open={isOpen}
        onClose={isLoading ? undefined : onClose}
        fullWidth
        maxWidth="xs"
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
      >
        <DialogTitle id={titleId}>{action} API key?</DialogTitle>
        <DialogContent>
          <SoftTypography
            id={descriptionId}
            component="p"
            variant="body2"
            color="text"
            sx={{ mt: 2, overflowWrap: "anywhere" }}
          >
            {action} the API key with prefix <strong>{prefix}</strong>? Applications using this key{" "}
            {active
              ? "will no longer be able to authenticate."
              : "will be able to authenticate again."}
          </SoftTypography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
          <SoftButton variant="outlined" onClick={onClose} disabled={isLoading} autoFocus>
            Cancel
          </SoftButton>
          <SoftButton
            color={active ? "error" : "info"}
            onClick={handleToggle}
            disabled={isLoading}
            isLoading={isLoading}
          >
            {action}
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

ToggleApiKeyStatus.propTypes = {
  apiKeyId: PropTypes.string.isRequired,
  brandId: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  prefix: PropTypes.string.isRequired,
};

export default ToggleApiKeyStatus;
